import { clsx } from "clsx";

interface TextInputNewProps {
  placeholder?: string;
  label?: string;
  onChange: (value: string) => any;
  type?: string;
  onEnter?: () => void;
  value?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
}

const TextInputNew = (props: TextInputNewProps) => {
  const variant = props.variant || 'primary';

  return (
    <div className={clsx("", props.className)}>
      {props.label && (
        <label
          htmlFor={props.label}
          className="block text-[#A39484] text-sm font-bold mb-2"
        >
          {props.label}
        </label>
      )}
      <input
        onClick={
          props.onClick
            ? (e) => {
              e.preventDefault();
              e.stopPropagation();
              props.onClick!();
            }
            : undefined
        }
        onKeyDown={
          !props.onEnter
            ? undefined
            : (e) => {
              if (e.key === "Enter") {
                props.onEnter!();
              }
            }
        }
        value={props.value}
        type={props.type}
        id={props.label}
        className={clsx(
          "appearance-none w-full rounded-[0.8rem] px-3 py-4",
          "border-2",
          "leading-tight",
          "focus:outline-none focus:shadow-outline",
          "transition-all duration-200",
          "placeholder:text-[#A39484]",
          variant === 'primary' && [
            "bg-[linear-gradient(180deg,#F5F0EC_32.97%,#EEE7E1_100.83%)]",
            "border-[#55402A]",
            "text-[#6E4A24]",
            "focus:border-[#68431c]",
          ],
          variant === 'secondary' && [
            "bg-[linear-gradient(180deg,#F5F0EC_32.97%,#EEE7E1_100.83%)]",
            "px-4",
            "border-[#CCC1B9]",
            "text-[#42311F]",
            "focus:border-[#886C4E]",
            "placeholder:text-[#AA9C8E]",
          ],
        )}
        placeholder={props.placeholder}
        onChange={(e) => props.onChange(e.target.value)}
      />
    </div>
  );
};

export default TextInputNew;